module.exports = __webpack_public_path__ + "icon-splunk.9j9bQitu.svg";